import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontNormal, fontCondensed } from "@fdr/static-ui/Typography";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${buildColor("white")};
`;

export const PlayerWrapper = styled.div<{ height: number }>`
  position: relative;
  background-color: #000;
  overflow: hidden;
  flex: 1;
  ${({ height }) => css`
    max-height: ${height}px;
    height: ${height}px;

    @media screen and (orientation: landscape) {
      height: 100vh;
      max-height: none;
    }
  `};
`;

export const CloseButton = styled.button<{ isXSell?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background-color: transparent;
  padding: ${({ isXSell }) => (isXSell ? "32px 16px" : "16px")};
`;

export const ReadingWrapper = styled.div<{
  titleOnly?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: ${({ titleOnly }) => (titleOnly ? "73px" : "109px")};
  padding: 16px 16px 32px;
  background-color: ${buildColor("white")};
`;

export const ClickableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const Title = styled.p`
  flex: 1;
  color: ${buildColor("navy")};
  font-family: ${fontNormal};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

export const Description = styled.p`
  flex: 1;
  color: ${buildColor("navy")};
  font-family: ${fontNormal};
  font-size: 14px;
  line-height: 18px;
  margin-right: 32px;
  min-height: 22px;
`;

export const Timestamp = styled.p`
  color: ${buildColor("grey", "D3")};
  font-family: ${fontCondensed};
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
`;
